<template>
    <div>
        <!-- Titulo -->
        <h3 class="mt-1 mb-2 " v-text="titulo"></h3>     

        <b-card>
           <alert
                :variant="alert.variant"            
                dismissible
                :mensagens="alert.mensagens"
                :value="alert.exibir"
                @input="alertDismissed">
            </alert>
            <b-row>
                <b-col>
                    <label class="text">Clique com botão direito no Órgão para alterá-lo como favorito (<i class="fa fa-star"></i>) ou não favorito (<i class="fa fa-star-o"></i>)</label>
                </b-col>
            </b-row> 
            <b-row class="mt-1">
                <b-col></b-col>  
                <b-col md="6" sm="12"  >
                    <b-input-group  size="sm">  
                        <b-form-input                             
                            id="filtro-sumario" 
                            v-model="filtroOrgaos" 
                            placeholder="Informe a sigla ou nome do órgão para filtrar"
                            @change="filtrarOrgaos()"       
                        >
                        </b-form-input>
                            
                        <b-input-group-append>
                            <b-button 
                                variant="primary"            
                                @click="filtrarOrgaos()"                                 
                                class="fa fa-filter" >
                            </b-button>
                        </b-input-group-append>
                    </b-input-group>
                </b-col>
            </b-row> 
            <b-row>
                <b-col class="text-center">
                    <tree-view  
                        v-if="treeDataFiltrada && treeDataFiltrada.length"
                        :data="treeDataFiltrada"                                                   
                        nameFieldLabel="sigla_nome_orgao"
                        nameFieldChildrens="orgaos_filhos"                                                                  
                        @nodeClick="nodeClick"
                        @nodeRightClick="nodeRightClick"
                        :key="treeViewKey"
                    >
                    </tree-view>
                    
                    <small v-else
                        class="text-muted">
                        Nenhum órgão encontrado
                    </small>  
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import Alert from '../../../models/Alert'
import TreeView  from "../../../components/TreeView/TreeView";

export default {
    
    components: {
        TreeView,
    },

    data() {
        return {
            titulo: "Órgãos",

            nome_orgao: '',

            filtro: {
                ind_favorito_dom: {
                    value: true,
                    options:[
                        { value: true, text: 'Sim' },     
                        { value: false, text: 'Não' },
                        { value: null, text: 'Todos' },     
                    ],
                },   
                ind_ativo: {
                    value: true,
                    options:[
                        { value: true, text: 'Ativos' },     
                        { value: false, text: 'Inativos' },
                        { value: 'T', text: 'Todos' },     
                    ],
                }                
            },
            treeData: [],    
            treeDataFiltrada: [],             
            selectedNode: null,
            alert: new Alert(),
            id_orgao_selecionado:null,                                               
            filtroOrgaos: '',
            treeViewKey: 0,            
        }
    },
    methods: {

        alertDismissed(){           
            this.alert = new Alert();
        },
       
        setShowDetailsOrgao(listaOrgaos, id, showDetails){
            listaOrgaos.forEach(orgao => {                    
                if(orgao.id === id){
                    orgao.showDetails = showDetails;
                }else{                
                    this.setShowDetailsOrgao(orgao.orgaos_filhos, id, showDetails);
                }
            });
        },

        nodeClick(node) {
           this.setShowDetailsOrgao(this.treeDataFiltrada, node.id, node._showDetails);                
        },
       
        nodeRightClick(node, event) {    
            event.preventDefault();    
   
            let message = 'Selecione a opção desejada para o Órgão "'+node.sigla_orgao+' - '+node.nome_orgao+'".'
            this.$helper.confirmaVoltar(this,message, 'Alteração Órgão','primary','Favorito','Não Favorito', false)
            .then(confirmado => {        
                if(confirmado !== null){
                    if(confirmado){
                        if(node.ind_favorito_dom == false){                                                                                                                             
                            this.editarAction(node, node.id, true);                              
                        }                        
                    }
                    else {
                        if(node.ind_favorito_dom == true){                                                                               
                            this.editarAction(node, node.id, false);                                                
                        }                         
                    }
                }
            }); 
                     
        },

        editarAction(orgao, id, indFavorito){
            let obj = {
                ind_favorito_dom: indFavorito
            }

            this.$api.orgao.editar(obj, id)
                .then(response => {                    
                    if(response.status == 200){
                        orgao.ind_favorito_dom = response.data.data.ind_favorito_dom;                                                    
                        orgao.icon = orgao.ind_favorito_dom  ? "fa fa-star" : "fa fa-star-o"; 
                        this.forceRerenderTreeView();
                        this.$helper.showAlert(this.alert, 
                                               this.$constantes.alert.variants.SUCCESS,
                                               'Registro atualizado com sucesso!');
                    } 
                })
                .catch(error => {                    
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                                       
                });  
        },

        forceRerenderTreeView() {
            this.treeViewKey += 1;
        },

        setTreeData(listaOrgaos){
            listaOrgaos.forEach(orgao => {
                orgao.sigla_nome_orgao = orgao.sigla_orgao +' - ' + orgao.nome_orgao;
                orgao.icon = orgao.ind_favorito_dom ?  "fa fa-star" : "fa fa-star-o";
                orgao.styleLink = 'text-decoration:none;';   

                if(orgao.orgaos_filhos.length === 0){
                    return;
                }else{
                   this.setTreeData(orgao.orgaos_filhos); 
                }
            });
        },


        listar(){
            this.$api.orgao.listar()
                .then(response => {
                    this.treeData = response.data.data;
                    this.setTreeData(this.treeData); 
                    this.treeDataFiltrada = this.treeData;
                })
                .catch(error => {
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.DANGER,
                                           error.response.data.errors);                                          
                }); 
        },


        filtrarOrgaos() {
            const getNodes = (result, object) => {
                if (object.sigla_nome_orgao.match(new RegExp(this.filtroOrgaos, "i"))) {
                    result.push(object);                    
                    return result;
                }
                
                if (Array.isArray(object.orgaos_filhos)) {                       
                   const nodes = object.orgaos_filhos.reduce(getNodes, []);
                      
                   if(nodes.length){
                       result = nodes;         
                   }       
                }
               
                return result;
            };

            this.treeDataFiltrada = this.treeData.reduce(getNodes, []);            
        },
        
    },

    mounted(){
        this.listar();
    },
    
}
</script>
<style scoped>
    .text{
        font-size: 0.9rem;
    }
</style>
